<template>
  <div>

    <div class="tabsBlock">
      <div v-for="(langName, lang) in LANGUAGES">
        <div
          @click="() => {setTabLang(lang)}"
          :class="tabLang === lang ? 'tab__active' : 'tab'"
        >
          {{ langName }}
        </div>
      </div>
    </div>

    <div v-for="(langName, lang) in LANGUAGES">
      <LangTab
        :visible="setLangToTab(lang)"
        :lang="lang"
        :name="langName"
        :description="langName"
      />
    </div>

  </div>
</template>

<script>
import {mapGetters} from "vuex";
import "./styles.scss"
import LangTab from "./Tab/index";
import {storeMixin} from "../../mixins/storeMixin";
import {configData} from "../../mixins/configData";

export default {
  mixins: [storeMixin, configData],
  name: "LangTabsBlock",
  components: {
    LangTab
  },
  computed: {
    ...mapGetters({
      tabLang: 'tenants/ticketTypes/tabLang'
    })
  },
  methods: {
    setLangToTab(lang) {
      return this.tabLang === lang ? 'block' : 'none'
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/tenants/ticket-types/ui/LangTabsBlock/index.vue